import angular from "angular";
import { IRestfulConfigMap } from "./restful-config-map";
import { IRestfulConfig } from "./restful-config";
import { ILogger } from "./logger";
import { HttpHandler } from "./http-handler";
import { IDataAccessor } from "../data-accessor";
import { IResponse } from "../model/response";
import { IPaging } from "../model/paging";
import { RuntimeContext } from "../../Environments";



export class RestfulAccessorProvider implements angular.IServiceProvider {

    private SERVICE_CONFIGS: IRestfulConfigMap = {};

    private readonly RETRY_MAX_TIME: number = 5;

    private readonly RETRY_TIME_SPAN: number = 3000;

    private readonly DEFAULT_HEADER: angular.IHttpRequestConfigHeaders = {
        "Content-Type": "application/json"
    }

    /**
     * 配置Rest请求
     * 
     * @param serviceName angular中的service名称
     * @param config rest配置
     * @param configs 配置对象，key需要是angular中的service名称
     */
    public config(configs: IRestfulConfigMap);
    public config(serviceName: string, config: IRestfulConfig);
    public config(nameOrConfigs: string | IRestfulConfigMap, config?: IRestfulConfig) {
        if (typeof (nameOrConfigs) == "string" && config != undefined) {
            this.SERVICE_CONFIGS[nameOrConfigs.toLowerCase()] = config;
        } else if (typeof nameOrConfigs == "object") {
            let configs = Object.assign(nameOrConfigs);
            for (let k in configs) {
                const obj = configs[k];
                if (obj) {
                    this.SERVICE_CONFIGS[k.toLowerCase()] = obj;
                }
            }
        }
    }

    /**
     * service的工厂
     */
    public $get = ["$http", "$q", "$timeout", "$cacheFactory", "$injector","runtimeContext",
        function (
            $http: angular.IHttpService,
            $q: angular.IQService,
            $timeout: angular.ITimeoutService,
            $cacheFactory: angular.ICacheFactoryService,
            $injector: angular.auto.IInjectorService,
            runtimeContext:RuntimeContext
        ) {

            let $logger: ILogger | undefined = undefined

            if ($injector.has("$logger")) {
                $logger = $injector.get<ILogger>("$logger");
            }

            let _handler_ = new HttpHandler($http, $q, $timeout,runtimeContext, $cacheFactory, $logger);
            _handler_.init(this.SERVICE_CONFIGS, this.RETRY_MAX_TIME, this.RETRY_TIME_SPAN, this.DEFAULT_HEADER);
            let ctor: IDataAccessor<unknown> = function <T, R, S>(
                name: string,
                action: string,
                config?: { parameter?: S, data?: R, headers?: angular.IHttpRequestConfigHeaders }
            ): angular.IPromise<IResponse<T>> {
                return _handler_.http<T, R, S>(name, action, config);
            } as IDataAccessor<unknown>;

            /********************************** 公开方法，接口实现 *********************************************/
            ctor.get = function <T, S>(name: string, parameter?: S): angular.IPromise<IResponse<T>> {
                if (parameter) {
                    return _handler_.http<T, S>(name, "get", { "parameter": parameter });
                } else {
                    return _handler_.http<T>(name, "get");
                }
            };

            ctor.query = function <T, S>(name: string, parameter?: S): angular.IPromise<IResponse<IPaging<T>>> & angular.IPromise<IResponse<Array<T>>> {
                if (parameter) {
                    return _handler_.http<IPaging<T> & Array<T>, S>(name, "query", { "parameter": parameter });
                } else {
                    return _handler_.http<IPaging<T> & Array<T>>(name, "query");
                }
            };

            ctor.save = function <R, S>(name: string, data: R, parameter?: S): angular.IPromise<IResponse<boolean & unknown>> {
                if (parameter) {
                    return _handler_.http<boolean & unknown, R, S>(name, "save", { "data": data, "parameter": parameter });
                } else {
                    return _handler_.http<boolean & unknown, R>(name, "save", { "data": data });
                }
            }

            ctor.update = function <R, S>(name: string, data: R, parameter?: S): angular.IPromise<IResponse<boolean & unknown>> {
                if (parameter) {
                    return _handler_.http<boolean & unknown, R, S>(name, "update", { "data": data, "parameter": parameter });
                } else {
                    return _handler_.http<boolean & unknown, R>(name, "update", { "data": data });
                }
            }

            ctor.delete = function <S>(name: string, parameter?: S): angular.IPromise<IResponse<boolean>> {
                if (parameter) {
                    return _handler_.http<boolean, S>(name, "delete", { "parameter": parameter });
                } else {
                    return _handler_.http<boolean>(name, "delete");
                }
            }

            return ctor;
        }
    ];
}